import type { GroupDto } from "@ied/shared-types";
import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

type CreateGroupBody = Pick<GroupDto, "group_name" | "abbreviation" | "status">;

export function useCreateGroup() {
	return useMutation({
		mutationKey: ["groups"],
		mutationFn: async (data: CreateGroupBody) => {
			const res = await fetch(`${SERVICE_API}/api/groups`, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify(data),
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to create group");
			}

			return (await res.json()) as GroupDto;
		},
	});
}
